import Fallback from "app/components/Fallback";
import React from "react";

const Library = React.lazy(() =>
  import("app/modules/library/pages/Library")
);

export const LibraryPage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <Library {...props} />
  </React.Suspense>
);
